import { useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { paymentMethodCodes } from '../../../constants/paymentMethods';
import { getMethod } from '../../../utils/paymentMethods';
import { initSession } from '../utils/session';
import type { TransformedPaymentMethod } from '../../../models';

export const usePayPal = (paymentMethods: TransformedPaymentMethod[]) => {
  const [payPalSessionData, setPayPalSessionData] = useState('');

  useDeepCompareEffect(() => {
    const paypalPaymentMethod = getMethod(paymentMethods, paymentMethodCodes.PAYPAL);

    const initPayPal = async () => {
      const sessionData = await initSession();
      setPayPalSessionData(sessionData.token);
    };
    if (paypalPaymentMethod) {
      initPayPal();
    }
  }, [paymentMethods]);

  return { payPalSessionData };
};
